interface UserWithName {
    firstName?: string | null;
    lastName?: string | null;
    preferredName?: string | null;
}

interface EntityWithUser {
    user?: { firstName?: string | null; lastName?: string | null } | null;
}

function getFirstName(
    user: UserWithName | null | undefined,
    entity: EntityWithUser | null | undefined,
): string | null {
    if (user?.firstName) {
        return user.firstName;
    }

    if (entity?.user?.firstName) {
        return entity.user.firstName;
    }

    if (user?.preferredName) {
        return user.preferredName.split(" ")[0];
    }

    return null;
}

function getLastName(
    user: UserWithName | null | undefined,
    entity: EntityWithUser | null | undefined,
): string | null {
    if (user?.lastName) {
        return user.lastName;
    }

    if (entity?.user?.lastName) {
        return entity.user.lastName;
    }

    if (user?.preferredName) {
        const parts = user.preferredName.split(" ");
        return parts.slice(1).join(" ") ?? "";
    }

    return null;
}

export function useUserDisplayNames(
    user: UserWithName | null | undefined,
    entity: EntityWithUser | null | undefined,
): { firstName: string | null; lastName: string | null } {
    return {
        firstName: getFirstName(user, entity),
        lastName: getLastName(user, entity),
    };
}
